module.exports = __webpack_public_path__ + "static/mondrakerhome-6f29302713c2d597d38ee8d6f27ec55a.jpg";